export default class Source {
    // static address = 'http://192.168.0.105:8000';
    // static address = 'http://127.0.0.1:8000';
    // static address = 'https://mydb.hashmatict.com';// exp exchange
    static address = 'https://demo.hashmatict.com';///stock of erp
    static getAddress() {
        return this.address;
    }
}